import { z } from 'zod';
import { isoDateTime } from './common';

/**
 * Admin-only "Agenda" event (Eid, national holidays, ad-hoc reminders).
 *
 * The unified Agenda view in the admin merges three sources:
 *   1. Derived: participant birthdays (from inscriptions.profile.birthdate).
 *   2. Derived: module dates (from formations.sessions[].moduleDates).
 *   3. Stored: these `agendaEvents` — anything the admin wants to track.
 *
 * Only (3) needs storage. (1) and (2) are computed live from existing data.
 */
export const agendaEventKindSchema = z.enum(['holiday', 'special', 'other']);
export type AgendaEventKind = z.infer<typeof agendaEventKindSchema>;

export const agendaEventInputSchema = z.object({
  title: z.string().min(1).max(200),
  /** Start date/time (ISO). For all-day events any time is fine. */
  date: isoDateTime,
  /** Optional end date for multi-day events (Eid is often 2 days). */
  endDate: isoDateTime.nullable().default(null),
  kind: agendaEventKindSchema.default('special'),
  notes: z.string().max(1000).optional(),
});
export type AgendaEventInput = z.infer<typeof agendaEventInputSchema>;

export const agendaEventSchema = agendaEventInputSchema.extend({
  id: z.string(),
  createdAt: isoDateTime,
  updatedAt: isoDateTime,
});
export type AgendaEvent = z.infer<typeof agendaEventSchema>;
